import { logger } from '../utils/logger';
export var SecurityLevel;
(function (SecurityLevel) {
    SecurityLevel["STRICT"] = "strict";
    SecurityLevel["BALANCED"] = "balanced";
    SecurityLevel["PERMISSIVE"] = "permissive";
    SecurityLevel["DEVELOPMENT"] = "development";
})(SecurityLevel || (SecurityLevel = {}));
export const SECURITY_PROFILES = {
    [SecurityLevel.STRICT]: {
        level: SecurityLevel.STRICT,
        allowUIInteractions: false,
        allowDOMQueries: false,
        allowPropertyAccess: true,
        allowAssignments: false,
        allowFunctionCalls: [],
        riskThreshold: 'low',
    },
    [SecurityLevel.BALANCED]: {
        level: SecurityLevel.BALANCED,
        allowUIInteractions: true,
        allowDOMQueries: true,
        allowPropertyAccess: true,
        allowAssignments: false,
        allowFunctionCalls: [
            'querySelector',
            'querySelectorAll',
            'getElementById',
            'getElementsByClassName',
            'getElementsByTagName',
            'getComputedStyle',
            'getBoundingClientRect',
            'focus',
            'blur',
            'scrollIntoView',
            'dispatchEvent',
        ],
        riskThreshold: 'medium',
    },
    [SecurityLevel.PERMISSIVE]: {
        level: SecurityLevel.PERMISSIVE,
        allowUIInteractions: true,
        allowDOMQueries: true,
        allowPropertyAccess: true,
        allowAssignments: true,
        allowFunctionCalls: [
            'querySelector',
            'querySelectorAll',
            'getElementById',
            'getElementsByClassName',
            'getElementsByTagName',
            'getComputedStyle',
            'getBoundingClientRect',
            'focus',
            'blur',
            'scrollIntoView',
            'dispatchEvent',
            'click',
            'submit',
            'addEventListener',
            'removeEventListener',
        ],
        riskThreshold: 'high',
    },
    [SecurityLevel.DEVELOPMENT]: {
        level: SecurityLevel.DEVELOPMENT,
        allowUIInteractions: true,
        allowDOMQueries: true,
        allowPropertyAccess: true,
        allowAssignments: true,
        allowFunctionCalls: ['*'], // Allow all function calls
        riskThreshold: 'critical',
    },
};
export function getSecurityConfig(level = SecurityLevel.BALANCED) {
    const profile = SECURITY_PROFILES[level];
    return {
        defaultRiskThreshold: profile.riskThreshold,
        enableInputValidation: true,
        enableAuditLog: true,
        enableSandbox: level !== SecurityLevel.DEVELOPMENT,
        enableScreenshotEncryption: level !== SecurityLevel.DEVELOPMENT,
    };
}
/**
 * Get the default security level from environment variable or fallback to BALANCED
 * Environment variable: SECURITY_LEVEL
 * Valid values: strict, balanced, permissive, development
 */
export function getDefaultSecurityLevel() {
    const envSecurityLevel = process.env.SECURITY_LEVEL;
    if (envSecurityLevel) {
        const normalizedLevel = envSecurityLevel.toLowerCase();
        // Check if the provided value is a valid SecurityLevel
        if (Object.values(SecurityLevel).includes(normalizedLevel)) {
            logger.info(`Using security level from environment: ${normalizedLevel}`);
            return normalizedLevel;
        }
        else {
            logger.warn(`Invalid security level in environment variable: ${envSecurityLevel}. Valid values are: ${Object.values(SecurityLevel).join(', ')}. Falling back to BALANCED.`);
        }
    }
    logger.info('Using BALANCED security level (default)');
    return SecurityLevel.BALANCED;
}
